/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React from 'react';
import { View, StyleSheet, TouchableWithoutFeedback } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';

function SociollaCard({
  children,
  borderColor,
  header,
  style,
  title,
  titleStyle,
  onPress,
  testID,
}) {
  return (
    <TouchableWithoutFeedback
      testID={testID}
      onPress={() => (onPress ? onPress() : false)}>
      <View
        style={[
          styles.card,
          style,
          borderColor && { borderColor },
          isWeb ? { cursor: 'pointer' } : {},
        ]}>
        {header ? (
          header
        ) : title ? (
          <SociollaText type="medium" style={[styles.title, titleStyle]}>
            {title}
          </SociollaText>
        ) : null}
        {children}
      </View>
    </TouchableWithoutFeedback>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 5,
    backgroundColor: Colors.white,
    marginBottom: isWeb ? 30 : 20,
    overflow: 'hidden',
    padding: 16,
  },
  title: {
    fontSize: 18,
    color: Colors.black0,
  },
});

export default SociollaCard;
